import { render, staticRenderFns } from "./BuyersCooperationUsersDialog.vue?vue&type=template&id=9e870916&scoped=true&"
import script from "./BuyersCooperationUsersDialog.vue?vue&type=script&lang=js&"
export * from "./BuyersCooperationUsersDialog.vue?vue&type=script&lang=js&"
import style0 from "./BuyersCooperationUsersDialog.vue?vue&type=style&index=0&id=9e870916&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e870916",
  null
  
)

export default component.exports